import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4f7c5ca4&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c5ca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7c5ca4')) {
      api.createRecord('4f7c5ca4', component.options)
    } else {
      api.reload('4f7c5ca4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4f7c5ca4&scoped=true&", function () {
      api.rerender('4f7c5ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mitumori/detail.vue"
export default component.exports